// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import t from 'tcomb';

const DealerRecommendation = t.struct({
    currentDealer: Dealer,
    currentDealerDistance: t.Number,
    customer: CustomerSummary,
	distanceMessage: t.String,
    id: t.String,
    lastServiceDate: t.Number,
    lastUpdatedDate: t.Number,
    newDealer: Dealer,
    pin: t.String,
}, {
    name: 'DealerRecommendation',
    strict: true
});

export const getDefaultState = () => new DealerRecommendation({
    currentDealer: getDealerDefaultState(),
    currentDealerDistance: 0,
    customer: getCustomerDefaultState(),
	distanceMessage: '',
    id: '',
    lastServiceDate: 0,
    lastUpdatedDate: 0,
    newDealer: getDealerDefaultState(),
    pin: ''
});

export default DealerRecommendation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-recommendation.js